// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MultipleSelectTableModal_wrapper__v66qF"};